import { Phone, Mail, Clock, UserCircle2 } from "lucide-react";
import { BRAND } from "@/lib/site";
import { TESTIDS } from "@/constants/testIds/site";

export const ContactPanel = () => {
  return (
    <aside
      data-testid={TESTIDS.contactPanel}
      className="hairline bg-white p-8 md:p-10 sticky top-[96px]"
    >
      <div className="eyebrow">Prefer to call now?</div>
      <a
        href={`tel:${BRAND.phoneRaw}`}
        data-testid={TESTIDS.contactPanelCall}
        className="block mt-3 font-serif text-[40px] leading-none tracking-tight text-[var(--primary)] hover:text-[var(--primary-hover)]"
      >
        {BRAND.phone}
      </a>
      <a
        href={`tel:${BRAND.phoneSecondaryRaw}`}
        data-testid="contact-panel-call-secondary"
        className="mt-3 inline-flex items-center gap-2 text-[13px] font-semibold tracking-wide text-[var(--text-main)] hover:text-[var(--primary)]"
      >
        <span className="text-[11px] uppercase tracking-[0.18em] text-[var(--text-muted)] font-bold">
          Alt
        </span>
        {BRAND.phoneSecondary}
      </a>
      <a
        href={`tel:${BRAND.phoneRaw}`}
        className="mt-5 btn-primary w-full justify-center"
      >
        <Phone size={14} strokeWidth={1.7} />
        Click to call leasing
      </a>

      <div className="divider-rule my-8" />

      <div className="eyebrow">Speak to leasing</div>
      <div className="mt-4 flex items-start gap-4">
        <div className="hairline w-12 h-12 flex items-center justify-center rounded-full">
          <UserCircle2 size={26} strokeWidth={1.2} className="text-[var(--primary)]" />
        </div>
        <div>
          <div className="font-serif text-[20px] leading-tight text-[var(--text-main)]">
            {BRAND.leasingAgent.name}
          </div>
          <div className="text-[12px] text-[var(--text-muted)] tracking-wide">
            {BRAND.leasingAgent.title}
          </div>
        </div>
      </div>

      <div className="divider-rule my-8" />

      <div className="space-y-4 text-[14px]">
        <a
          href={`mailto:${BRAND.email}`}
          data-testid={TESTIDS.contactPanelEmail}
          className="flex items-center gap-3 text-[var(--text-main)] hover:text-[var(--primary)]"
        >
          <Mail size={15} strokeWidth={1.5} className="text-[var(--primary)]" />
          {BRAND.email}
        </a>
        <div className="flex items-start gap-3">
          <Clock size={15} strokeWidth={1.5} className="mt-1 text-[var(--primary)]" />
          <ul className="space-y-1">
            {BRAND.hours.map((h) => (
              <li key={h.label} className="flex justify-between gap-6">
                <span className="text-[var(--text-main)]">{h.label}</span>
                <span className="text-[var(--text-muted)]">{h.value}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default ContactPanel;
